const inquiryMutations = {
  setFormItems(state, payload) {
    const name = payload.name;
    const value = payload.value;
    state.formItems[name] = value;
  },
}
const inquiryActions = {
  updateFormItems(store, formItem) {
    store.commit('setFormItems', formItem);
  },
  // サーバサイドバリデーション
  validateInquiry({state}) {
    return axios.post('/api/inquiry/validate', {
      name: state.formItems.name,
      mail: state.formItems.email,
      type: state.formItems.inquiryTypeCode,
      detail: state.formItems.inquiryDetail,
      siteCode: state.formItems.siteCode,
    });
  },
  // お問い合わせを登録する
  applyInquiryForm({state}) {
    return axios.post('/api/inquiry/apply', {
      name: state.formItems.name,
      mail: state.formItems.email,
      type: state.formItems.inquiryTypeCode,
      detail: state.formItems.inquiryDetail,
      siteCode: state.formItems.siteCode,
    });
  },
}
const inquiryGetters = {
  getFormItems: (state) => {
    return state.formItems;
  },
}

const defaultInquiryState = () => {
  return {
    formItems: {
      siteCode: null,
      name: null,
      email: null,
      inquiryTypeCode: null,
      inquiryDetail: null,
    }
  }
}

const moduleInquiry = {
  namespaced: true,
  state: defaultInquiryState(),
  mutations: inquiryMutations,
  actions: inquiryActions,
  getters: inquiryGetters
}

export {moduleInquiry};